// extracted by mini-css-extract-plugin
export default {"shipping":"kh-z","header":"lh-z","adjustMarginAndPaddingNewDesign":"mh-z"};